<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle
      }">
        <!-- Subject Dropdown -->
        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Methode</label>
                <select class="form-control" [(ngModel)]="selectedSubjectId"
                    (change)="fetchCourseSections(selectedSubjectId)">
                    <option value="">Selecteer een methode</option>
                    <ng-container *ngFor="let subject of productSubjects">
                        <option [value]="subject.id">{{ subject.title }}</option>
                    </ng-container>
                </select>
            </div>
        </div>

        <!-- Sections Table -->
        <div *ngIf="courseSections.length">
            <table class="table">
                <thead>
                    <tr>
                        <th>Module</th>
                        <th><input [(ngModel)]="searchTerm" type="text" placeholder="Zoeken.." class="form-control"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let section of courseSections">
                        <ng-container *ngFor="let chapter of section['chapters']">
                            <tr *ngIf="canShow(section.title + ' / ' + chapter.title)">
                                <td>
                                    <input #input type="checkbox" [value]="chapter.id" [(ngModel)]="chapter.checked"
                                        (change)="toggleChapterSelection(chapter)" />
                                </td>
                                <td (click)="input.click()">{{ section.title }} / {{ chapter.title }}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Form Buttons -->
        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="addChapters()">
                Opslaan
            </button>
        </div>
    </div>
</div>